const normalize = (value) => String(value || '')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

const RULES = [
  ['AFD', 100, [/analyse fonctionnelle detaillee/]],
  ['LIO', 100, [/liste (des )?entrees sorties/, /liste e s/]],
  ['LGT', 100, [/liste des (termes|points).*(gtc|gtb|scada)/, /(gtc|gtb|scada).*liste des (termes|points)/]],
  ['SOA', 100, [/specification organique.*(automate|ihm)/]],
  ['PRG', 100, [/programme.*(api|automate|ihm)/]],
  ['FAT', 100, [/procedure.*recette usine/, /recette usine/]],
  ['PCE', 100, [/plan de controle.*essai/]],
  ['INT', 100, [/procedure.*essai.*interface/, /essai.*interface.*(scada|gtc|gtb)/]],
  ['MES', 100, [/procedure.*mise sous tension/, /procedure.*mise en service/]],
  ['PES', 90, [/procedure.*essai/, /procedure des essais/]],
  ['CEMR', 100, [/rapport.*(inspection|essai).*cem/, /synthese.*conformite.*cem/]],
  ['CEM', 95, [/plan de controle.*cem/, /analyse.*cem/, /etude.*cem/]],
  ['MNT', 100, [/plan de maintenance/]],
  ['FOR', 100, [/(manuel|support).*formation/]],
  ['FMDP', 100, [/plan fmd/]],
  ['FMDD', 95, [/dossier.*demonstration.*(fmd|fms)/, /demonstration.*suivi.*(fmd|fms)/]],
  ['PAQ', 100, [/plan.*assurance qualite/, /\bpaq\b/]],
  ['PRE', 95, [/plan.*(respect|assurance|management).*environnement/, /\b(pre|pae|pme)\b/]],
  ['SOG', 100, [/schema.*organisation.*gestion.*dechet/, /\bsoged\b/]],
  ['DMA', 100, [/demande.*agrement/, /dossier.*agrement/]],
  ['BDP', 100, [/bilan de puissance/]],
  ['NDE', 100, [/note de calcul.*(eclairage|eclairement)/]],
  ['NDC', 95, [/note de calcul.*cable.*bt/, /note de calcul.*bt/]],
  ['NCA', 88, [/note de calcul/, /calcul.*court circuit/, /reglage.*protection/]],
  ['UCF', 98, [/schema unifilaire.*(basse tension|bt|tgbt|cfo)/]],
  ['UPV', 100, [/schema unifilaire.*pv/, /schema unifilaire.*photovoltai/]],
  ['UNI', 92, [/schema unifilaire/]],
  ['SBA', 100, [/schema.*baie/]],
  ['VER', 100, [/(plan|schema).*verrouillage/]],
  ['ZON', 100, [/plan.*zonage.*ssi/]],
  ['COR', 100, [/tableau.*correlation.*ssi/]],
  ['SCE', 100, [/(scenario|matrice).*mise en securite.*ssi/]],
  ['RAC', 96, [/(carnet|plan).*(raccordement)/]],
  ['CDC', 92, [/carnet de cables/]],
  ['PEQ', 96, [/plan d equipement/]],
  ['RES', 100, [/plan.*reservation/]],
  ['INC', 100, [/plan.*incorporation/]],
  ['CHE', 100, [/plan.*cheminement/]],
  ['CIR', 100, [/plan.*circuit/]],
  ['CPV', 100, [/plan.*cablage.*module.*(pv|photovoltai)/]],
  ['IMP', 88, [/plan.*implantation/, /plan bim.*implantation/]],
  ['FTE', 95, [/fiche.*technique/]],
  ['LST', 95, [/liste.*materiel/]],
  ['PRO', 75, [/procedure/, /methodologie/]],
  ['SYN', 88, [/synoptique/]],
  ['SCH', 75, [/schema.*(principe|fonctionnel)/]],
  ['DOE', 100, [/\bdoe\b/, /dossier.*ouvrages executes/]],
];

export function classifyLdaDeliverable({ label, reference = '', notes = '', catalog = {} } = {}) {
  const text = normalize([label, reference, notes].filter(Boolean).join(' '));
  if (!text) return null;
  const available = new Set((catalog.deliverables || []).map((entry) => String(entry.code || '').toUpperCase()));
  const matches = [];
  RULES.forEach(([code, score, patterns]) => {
    if (!available.has(code)) return;
    if (patterns.some((pattern) => pattern.test(text))) matches.push({ code, score });
  });
  if (!matches.length) return null;
  matches.sort((a, b) => b.score - a.score);
  const best = matches[0];
  return {
    code: best.code,
    confidence: best.score >= 95 ? 'high' : best.score >= 85 ? 'medium' : 'low',
    score: best.score,
    alternatives: matches.slice(1, 4).map((entry) => entry.code),
    method: 'rules-v1',
  };
}
